(() => {
  const inquiryLabel = 'inquire for availability';

  const openInquiry = (target) => {
    const trigger = target.querySelector('.collapsible-trigger');
    if (!trigger) return;

    const panelId = trigger.getAttribute('aria-controls');
    const panel = panelId ? document.getElementById(panelId) : null;
    const isOpen = trigger.getAttribute('aria-expanded') === 'true' || (panel && panel.getBoundingClientRect().height > 1);

    if (!isOpen) trigger.click();

    window.setTimeout(() => {
      const y = target.getBoundingClientRect().top + window.pageYOffset - 110;
      window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    }, 80);
  };

  document.addEventListener('click', (event) => {
    const control = event.target.closest('a, button, [role="button"]');
    if (!control) return;

    const label = (control.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
    if (!label.includes(inquiryLabel)) return;

    const target = document.querySelector('[data-gtj-product-inquire]');
    if (!target) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    openInquiry(target);
  }, true);
})();
